import _defineProperty from "/var/www/polishfilmcommission.pl/releases/1/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/polishfilmcommission.pl/releases/1/frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "htmlAttributes", "meta", "relatedPaths", "baseUrl"];
import e from "react";
function t() {
  return t = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  }, t.apply(this, arguments);
}
var r = {
    exports: {}
  },
  n = {
    exports: {}
  },
  o = {},
  i = "function" == typeof Symbol && Symbol.for,
  a = i ? Symbol.for("react.element") : 60103,
  c = i ? Symbol.for("react.portal") : 60106,
  u = i ? Symbol.for("react.fragment") : 60107,
  s = i ? Symbol.for("react.strict_mode") : 60108,
  f = i ? Symbol.for("react.profiler") : 60114,
  l = i ? Symbol.for("react.provider") : 60109,
  p = i ? Symbol.for("react.context") : 60110,
  y = i ? Symbol.for("react.async_mode") : 60111,
  d = i ? Symbol.for("react.concurrent_mode") : 60111,
  m = i ? Symbol.for("react.forward_ref") : 60112,
  b = i ? Symbol.for("react.suspense") : 60113,
  h = i ? Symbol.for("react.suspense_list") : 60120,
  v = i ? Symbol.for("react.memo") : 60115,
  g = i ? Symbol.for("react.lazy") : 60116,
  T = i ? Symbol.for("react.block") : 60121,
  w = i ? Symbol.for("react.fundamental") : 60117,
  O = i ? Symbol.for("react.responder") : 60118,
  S = i ? Symbol.for("react.scope") : 60119;
function E(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case a:
        switch (e = e.type) {
          case y:
          case d:
          case u:
          case f:
          case s:
          case b:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case p:
              case m:
              case g:
              case v:
              case l:
                return e;
              default:
                return t;
            }
        }
      case c:
        return t;
    }
  }
}
function A(e) {
  return E(e) === d;
}
o.AsyncMode = y, o.ConcurrentMode = d, o.ContextConsumer = p, o.ContextProvider = l, o.Element = a, o.ForwardRef = m, o.Fragment = u, o.Lazy = g, o.Memo = v, o.Portal = c, o.Profiler = f, o.StrictMode = s, o.Suspense = b, o.isAsyncMode = function (e) {
  return A(e) || E(e) === y;
}, o.isConcurrentMode = A, o.isContextConsumer = function (e) {
  return E(e) === p;
}, o.isContextProvider = function (e) {
  return E(e) === l;
}, o.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === a;
}, o.isForwardRef = function (e) {
  return E(e) === m;
}, o.isFragment = function (e) {
  return E(e) === u;
}, o.isLazy = function (e) {
  return E(e) === g;
}, o.isMemo = function (e) {
  return E(e) === v;
}, o.isPortal = function (e) {
  return E(e) === c;
}, o.isProfiler = function (e) {
  return E(e) === f;
}, o.isStrictMode = function (e) {
  return E(e) === s;
}, o.isSuspense = function (e) {
  return E(e) === b;
}, o.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === u || e === d || e === f || e === s || e === b || e === h || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === v || e.$$typeof === l || e.$$typeof === p || e.$$typeof === m || e.$$typeof === w || e.$$typeof === O || e.$$typeof === S || e.$$typeof === T);
}, o.typeOf = E;
var C = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    r = e ? Symbol.for("react.portal") : 60106,
    n = e ? Symbol.for("react.fragment") : 60107,
    o = e ? Symbol.for("react.strict_mode") : 60108,
    i = e ? Symbol.for("react.profiler") : 60114,
    a = e ? Symbol.for("react.provider") : 60109,
    c = e ? Symbol.for("react.context") : 60110,
    u = e ? Symbol.for("react.async_mode") : 60111,
    s = e ? Symbol.for("react.concurrent_mode") : 60111,
    f = e ? Symbol.for("react.forward_ref") : 60112,
    l = e ? Symbol.for("react.suspense") : 60113,
    p = e ? Symbol.for("react.suspense_list") : 60120,
    y = e ? Symbol.for("react.memo") : 60115,
    d = e ? Symbol.for("react.lazy") : 60116,
    m = e ? Symbol.for("react.block") : 60121,
    b = e ? Symbol.for("react.fundamental") : 60117,
    h = e ? Symbol.for("react.responder") : 60118,
    v = e ? Symbol.for("react.scope") : 60119;
  function g(e) {
    if ("object" == typeof e && null !== e) {
      var p = e.$$typeof;
      switch (p) {
        case t:
          var m = e.type;
          switch (m) {
            case u:
            case s:
            case n:
            case i:
            case o:
            case l:
              return m;
            default:
              var b = m && m.$$typeof;
              switch (b) {
                case c:
                case f:
                case d:
                case y:
                case a:
                  return b;
                default:
                  return p;
              }
          }
        case r:
          return p;
      }
    }
  }
  var T = u,
    w = s,
    O = c,
    S = a,
    E = t,
    A = f,
    j = n,
    P = d,
    x = y,
    k = r,
    I = i,
    _ = o,
    $ = l,
    N = !1;
  function R(e) {
    return g(e) === s;
  }
  C.AsyncMode = T, C.ConcurrentMode = w, C.ContextConsumer = O, C.ContextProvider = S, C.Element = E, C.ForwardRef = A, C.Fragment = j, C.Lazy = P, C.Memo = x, C.Portal = k, C.Profiler = I, C.StrictMode = _, C.Suspense = $, C.isAsyncMode = function (e) {
    return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(e) || g(e) === u;
  }, C.isConcurrentMode = R, C.isContextConsumer = function (e) {
    return g(e) === c;
  }, C.isContextProvider = function (e) {
    return g(e) === a;
  }, C.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, C.isForwardRef = function (e) {
    return g(e) === f;
  }, C.isFragment = function (e) {
    return g(e) === n;
  }, C.isLazy = function (e) {
    return g(e) === d;
  }, C.isMemo = function (e) {
    return g(e) === y;
  }, C.isPortal = function (e) {
    return g(e) === r;
  }, C.isProfiler = function (e) {
    return g(e) === i;
  }, C.isStrictMode = function (e) {
    return g(e) === o;
  }, C.isSuspense = function (e) {
    return g(e) === l;
  }, C.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === n || e === s || e === i || e === o || e === l || e === p || "object" == typeof e && null !== e && (e.$$typeof === d || e.$$typeof === y || e.$$typeof === a || e.$$typeof === c || e.$$typeof === f || e.$$typeof === b || e.$$typeof === h || e.$$typeof === v || e.$$typeof === m);
  }, C.typeOf = g;
}(), "production" === process.env.NODE_ENV ? n.exports = o : n.exports = C
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/;
var j = Object.getOwnPropertySymbols,
  P = Object.prototype.hasOwnProperty,
  x = Object.prototype.propertyIsEnumerable;
function k(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
var I = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, r = 0; r < 10; r++) {
        t["_" + String.fromCharCode(r)] = r;
      }
      var n = Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      });
      if ("0123456789" !== n.join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var r, n, o = k(e), i = 1; i < arguments.length; i++) {
      for (var a in r = Object(arguments[i])) {
        P.call(r, a) && (o[a] = r[a]);
      }
      if (j) {
        n = j(r);
        for (var c = 0; c < n.length; c++) {
          x.call(r, n[c]) && (o[n[c]] = r[n[c]]);
        }
      }
    }
    return o;
  },
  _ = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  $ = Function.call.bind(Object.prototype.hasOwnProperty),
  N = function N() {};
if ("production" !== process.env.NODE_ENV) {
  var R = _,
    L = {},
    M = $;
  N = function N(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);
    try {
      throw new Error(t);
    } catch (e) {}
  };
}
function D(e, t, r, n, o) {
  if ("production" !== process.env.NODE_ENV) for (var i in e) {
    if (M(e, i)) {
      var a;
      try {
        if ("function" != typeof e[i]) {
          var c = Error((n || "React class") + ": " + r + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
          throw c.name = "Invariant Violation", c;
        }
        a = e[i](t, i, n, r, null, R);
      } catch (e) {
        a = e;
      }
      if (!a || a instanceof Error || N((n || "React class") + ": type specification of " + r + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in L)) {
        L[a.message] = !0;
        var u = o ? o() : "";
        N("Failed " + r + " type: " + a.message + (null != u ? u : ""));
      }
    }
  }
}
D.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (L = {});
};
var F = D,
  V = n.exports,
  q = I,
  H = _,
  Y = $,
  B = F,
  U = function U() {};
function z() {
  return null;
}
"production" !== process.env.NODE_ENV && (U = function U(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);
  try {
    throw new Error(t);
  } catch (e) {}
});
function W() {}
function K() {}
K.resetWarningCache = W;
if ("production" !== process.env.NODE_ENV) {
  var J = n.exports;
  r.exports = function (e, t) {
    var r = "function" == typeof Symbol && Symbol.iterator,
      n = "<<anonymous>>",
      o = {
        array: u("array"),
        bigint: u("bigint"),
        bool: u("boolean"),
        func: u("function"),
        number: u("number"),
        object: u("object"),
        string: u("string"),
        symbol: u("symbol"),
        any: c(z),
        arrayOf: function arrayOf(e) {
          return c(function (t, r, n, o, i) {
            if ("function" != typeof e) return new a("Property `" + i + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
            var c = t[r];
            if (!Array.isArray(c)) return new a("Invalid " + o + " `" + i + "` of type `" + l(c) + "` supplied to `" + n + "`, expected an array.");
            for (var u = 0; u < c.length; u++) {
              var s = e(c, u, n, o, i + "[" + u + "]", H);
              if (s instanceof Error) return s;
            }
            return null;
          });
        },
        element: c(function (t, r, n, o, i) {
          var c = t[r];
          return e(c) ? null : new a("Invalid " + o + " `" + i + "` of type `" + l(c) + "` supplied to `" + n + "`, expected a single ReactElement.");
        }),
        elementType: c(function (e, t, r, n, o) {
          var i = e[t];
          return V.isValidElementType(i) ? null : new a("Invalid " + n + " `" + o + "` of type `" + l(i) + "` supplied to `" + r + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(e) {
          return c(function (t, r, o, i, c) {
            if (!(t[r] instanceof e)) {
              var u = e.name || n;
              return new a("Invalid " + i + " `" + c + "` of type `" + ((s = t[r]).constructor && s.constructor.name ? s.constructor.name : n) + "` supplied to `" + o + "`, expected instance of `" + u + "`.");
            }
            var s;
            return null;
          });
        },
        node: c(function (e, t, r, n, o) {
          return f(e[t]) ? null : new a("Invalid " + n + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(e) {
          return c(function (t, r, n, o, i) {
            if ("function" != typeof e) return new a("Property `" + i + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
            var c = t[r],
              u = l(c);
            if ("object" !== u) return new a("Invalid " + o + " `" + i + "` of type `" + u + "` supplied to `" + n + "`, expected an object.");
            for (var s in c) {
              if (Y(c, s)) {
                var f = e(c, s, n, o, i + "." + s, H);
                if (f instanceof Error) return f;
              }
            }
            return null;
          });
        },
        oneOf: function oneOf(e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && U(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), z;
          function t(t, r, n, o, c) {
            for (var u = t[r], s = 0; s < e.length; s++) {
              if (i(u, e[s])) return null;
            }
            var f = JSON.stringify(e, function (e, t) {
              return "symbol" === p(t) ? String(t) : t;
            });
            return new a("Invalid " + o + " `" + c + "` of value `" + String(u) + "` supplied to `" + n + "`, expected one of " + f + ".");
          }
          return c(t);
        },
        oneOfType: function oneOfType(e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && U("Invalid argument supplied to oneOfType, expected an instance of array."), z;
          for (var t = 0; t < e.length; t++) {
            var r = e[t];
            if ("function" != typeof r) return U("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + y(r) + " at index " + t + "."), z;
          }
          return c(function (t, r, n, o, i) {
            for (var c = [], u = 0; u < e.length; u++) {
              var s = (0, e[u])(t, r, n, o, i, H);
              if (null == s) return null;
              s.data && Y(s.data, "expectedType") && c.push(s.data.expectedType);
            }
            return new a("Invalid " + o + " `" + i + "` supplied to `" + n + "`" + (c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "") + ".");
          });
        },
        shape: function shape(e) {
          return c(function (t, r, n, o, i) {
            var c = t[r],
              u = l(c);
            if ("object" !== u) return new a("Invalid " + o + " `" + i + "` of type `" + u + "` supplied to `" + n + "`, expected `object`.");
            for (var f in e) {
              var y = e[f];
              if ("function" != typeof y) return s(n, o, i, f, p(y));
              var d = y(c, f, n, o, i + "." + f, H);
              if (d) return d;
            }
            return null;
          });
        },
        exact: function exact(e) {
          return c(function (t, r, n, o, i) {
            var c = t[r],
              u = l(c);
            if ("object" !== u) return new a("Invalid " + o + " `" + i + "` of type `" + u + "` supplied to `" + n + "`, expected `object`.");
            var f = q({}, t[r], e);
            for (var y in f) {
              var d = e[y];
              if (Y(e, y) && "function" != typeof d) return s(n, o, i, y, p(d));
              if (!d) return new a("Invalid " + o + " `" + i + "` key `" + y + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(t[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var m = d(c, y, n, o, i + "." + y, H);
              if (m) return m;
            }
            return null;
          });
        }
      };
    function i(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }
    function a(e, t) {
      this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
    }
    function c(e) {
      if ("production" !== process.env.NODE_ENV) var r = {},
        o = 0;
      function i(i, c, u, s, f, l, p) {
        if (s = s || n, l = l || u, p !== H) {
          if (t) {
            var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw y.name = "Invariant Violation", y;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var d = s + ":" + u;
            !r[d] && o < 3 && (U("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[d] = !0, o++);
          }
        }
        return null == c[u] ? i ? null === c[u] ? new a("The " + f + " `" + l + "` is marked as required in `" + s + "`, but its value is `null`.") : new a("The " + f + " `" + l + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(c, u, s, f, l);
      }
      var c = i.bind(null, !1);
      return c.isRequired = i.bind(null, !0), c;
    }
    function u(e) {
      return c(function (t, r, n, o, i, c) {
        var u = t[r];
        return l(u) !== e ? new a("Invalid " + o + " `" + i + "` of type `" + p(u) + "` supplied to `" + n + "`, expected `" + e + "`.", {
          expectedType: e
        }) : null;
      });
    }
    function s(e, t, r, n, o) {
      return new a((e || "React class") + ": " + t + " type `" + r + "." + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
    }
    function f(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t;
        case "object":
          if (Array.isArray(t)) return t.every(f);
          if (null === t || e(t)) return !0;
          var n = function (e) {
            var t = e && (r && e[r] || e["@@iterator"]);
            if ("function" == typeof t) return t;
          }(t);
          if (!n) return !1;
          var o,
            i = n.call(t);
          if (n !== t.entries) {
            for (; !(o = i.next()).done;) {
              if (!f(o.value)) return !1;
            }
          } else for (; !(o = i.next()).done;) {
            var a = o.value;
            if (a && !f(a[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function l(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }
    function p(e) {
      if (null == e) return "" + e;
      var t = l(e);
      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }
      return t;
    }
    function y(e) {
      var t = p(e);
      switch (t) {
        case "array":
        case "object":
          return "an " + t;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;
        default:
          return t;
      }
    }
    return a.prototype = Error.prototype, o.checkPropTypes = B, o.resetWarningCache = B.resetWarningCache, o.PropTypes = o, o;
  }(J.isElement, !0);
} else r.exports = function () {
  function e(e, t, r, n, o, i) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== i) {
      var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw a.name = "Invariant Violation", a;
    }
  }
  function t() {
    return e;
  }
  e.isRequired = e;
  var r = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: K,
    resetWarningCache: W
  };
  return r.PropTypes = r, r;
}();
var G = r.exports;
var Q,
  X = e,
  Z = (Q = X) && "object" == typeof Q && "default" in Q ? Q.default : Q;
function ee(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var te = !("undefined" == typeof window || !window.document || !window.document.createElement);
var re = function re(e, t, r) {
    if ("function" != typeof e) throw new Error("Expected reducePropsToState to be a function.");
    if ("function" != typeof t) throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (void 0 !== r && "function" != typeof r) throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    return function (n) {
      if ("function" != typeof n) throw new Error("Expected WrappedComponent to be a React component.");
      var o,
        i = [];
      function a() {
        o = e(i.map(function (e) {
          return e.props;
        })), c.canUseDOM ? t(o) : r && (o = r(o));
      }
      var c = function (e) {
        var t, r;
        function c() {
          return e.apply(this, arguments) || this;
        }
        r = e, (t = c).prototype = Object.create(r.prototype), t.prototype.constructor = t, t.__proto__ = r, c.peek = function () {
          return o;
        }, c.rewind = function () {
          if (c.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
          var e = o;
          return o = void 0, i = [], e;
        };
        var u = c.prototype;
        return u.UNSAFE_componentWillMount = function () {
          i.push(this), a();
        }, u.componentDidUpdate = function () {
          a();
        }, u.componentWillUnmount = function () {
          var e = i.indexOf(this);
          i.splice(e, 1), a();
        }, u.render = function () {
          return Z.createElement(n, this.props);
        }, c;
      }(X.PureComponent);
      return ee(c, "displayName", "SideEffect(" + function (e) {
        return e.displayName || e.name || "Component";
      }(n) + ")"), ee(c, "canUseDOM", te), c;
    };
  },
  ne = "undefined" != typeof Element,
  oe = "function" == typeof Map,
  ie = "function" == typeof Set,
  ae = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;
function ce(e, t) {
  if (e === t) return !0;
  if (e && t && "object" == typeof e && "object" == typeof t) {
    if (e.constructor !== t.constructor) return !1;
    var r, n, o, i;
    if (Array.isArray(e)) {
      if ((r = e.length) != t.length) return !1;
      for (n = r; 0 != n--;) {
        if (!ce(e[n], t[n])) return !1;
      }
      return !0;
    }
    if (oe && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(n = i.next()).done;) {
        if (!t.has(n.value[0])) return !1;
      }
      for (i = e.entries(); !(n = i.next()).done;) {
        if (!ce(n.value[1], t.get(n.value[0]))) return !1;
      }
      return !0;
    }
    if (ie && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(n = i.next()).done;) {
        if (!t.has(n.value[0])) return !1;
      }
      return !0;
    }
    if (ae && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if ((r = e.length) != t.length) return !1;
      for (n = r; 0 != n--;) {
        if (e[n] !== t[n]) return !1;
      }
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if ((r = (o = Object.keys(e)).length) !== Object.keys(t).length) return !1;
    for (n = r; 0 != n--;) {
      if (!Object.prototype.hasOwnProperty.call(t, o[n])) return !1;
    }
    if (ne && e instanceof Element) return !1;
    for (n = r; 0 != n--;) {
      if (("_owner" !== o[n] && "__v" !== o[n] && "__o" !== o[n] || !e.$$typeof) && !ce(e[o[n]], t[o[n]])) return !1;
    }
    return !0;
  }
  return e != e && t != t;
}
var ue,
  se,
  fe,
  le,
  pe = function pe(e, t) {
    try {
      return ce(e, t);
    } catch (e) {
      if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw e;
    }
  },
  ye = "bodyAttributes",
  de = "htmlAttributes",
  me = "titleAttributes",
  be = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
  },
  he = Object.keys(be).map(function (e) {
    return be[e];
  }),
  ve = "charset",
  ge = "cssText",
  Te = "href",
  we = "http-equiv",
  Oe = "innerHTML",
  Se = "itemprop",
  Ee = "name",
  Ae = "property",
  Ce = "rel",
  je = "src",
  Pe = "target",
  xe = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
  },
  ke = "defaultTitle",
  Ie = "defer",
  _e = "encodeSpecialCharacters",
  $e = "onChangeClientState",
  Ne = "titleTemplate",
  Re = Object.keys(xe).reduce(function (e, t) {
    return e[xe[t]] = t, e;
  }, {}),
  Le = [be.NOSCRIPT, be.SCRIPT, be.STYLE],
  Me = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  De = function De(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  },
  Fe = function () {
    function e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function (t, r, n) {
      return r && e(t.prototype, r), n && e(t, n), t;
    };
  }(),
  Ve = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  },
  qe = function qe(e, t) {
    var r = {};
    for (var n in e) {
      t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  },
  He = function He(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  },
  Ye = function Ye(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    return !1 === t ? String(e) : String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
  },
  Be = function Be(e) {
    var t = Je(e, be.TITLE),
      r = Je(e, Ne);
    if (r && t) return r.replace(/%s/g, function () {
      return Array.isArray(t) ? t.join("") : t;
    });
    var n = Je(e, ke);
    return t || n || void 0;
  },
  Ue = function Ue(e) {
    return Je(e, $e) || function () {};
  },
  ze = function ze(e, t) {
    return t.filter(function (t) {
      return void 0 !== t[e];
    }).map(function (t) {
      return t[e];
    }).reduce(function (e, t) {
      return Ve({}, e, t);
    }, {});
  },
  We = function We(e, t) {
    return t.filter(function (e) {
      return void 0 !== e[be.BASE];
    }).map(function (e) {
      return e[be.BASE];
    }).reverse().reduce(function (t, r) {
      if (!t.length) for (var n = Object.keys(r), o = 0; o < n.length; o++) {
        var i = n[o].toLowerCase();
        if (-1 !== e.indexOf(i) && r[i]) return t.concat(r);
      }
      return t;
    }, []);
  },
  Ke = function Ke(e, t, r) {
    var n = {};
    return r.filter(function (t) {
      return !!Array.isArray(t[e]) || (void 0 !== t[e] && et("Helmet: " + e + ' should be of type "Array". Instead found type "' + Me(t[e]) + '"'), !1);
    }).map(function (t) {
      return t[e];
    }).reverse().reduce(function (e, r) {
      var o = {};
      r.filter(function (e) {
        for (var r = void 0, i = Object.keys(e), a = 0; a < i.length; a++) {
          var c = i[a],
            u = c.toLowerCase();
          -1 === t.indexOf(u) || r === Ce && "canonical" === e[r].toLowerCase() || u === Ce && "stylesheet" === e[u].toLowerCase() || (r = u), -1 === t.indexOf(c) || c !== Oe && c !== ge && c !== Se || (r = c);
        }
        if (!r || !e[r]) return !1;
        var s = e[r].toLowerCase();
        return n[r] || (n[r] = {}), o[r] || (o[r] = {}), !n[r][s] && (o[r][s] = !0, !0);
      }).reverse().forEach(function (t) {
        return e.push(t);
      });
      for (var i = Object.keys(o), a = 0; a < i.length; a++) {
        var c = i[a],
          u = I({}, n[c], o[c]);
        n[c] = u;
      }
      return e;
    }, []).reverse();
  },
  Je = function Je(e, t) {
    for (var r = e.length - 1; r >= 0; r--) {
      var n = e[r];
      if (n.hasOwnProperty(t)) return n[t];
    }
    return null;
  },
  Ge = (ue = Date.now(), function (e) {
    var t = Date.now();
    t - ue > 16 ? (ue = t, e(t)) : setTimeout(function () {
      Ge(e);
    }, 0);
  }),
  Qe = function Qe(e) {
    return clearTimeout(e);
  },
  Xe = "undefined" != typeof window ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || Ge : global.requestAnimationFrame || Ge,
  Ze = "undefined" != typeof window ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || Qe : global.cancelAnimationFrame || Qe,
  et = function et(e) {
    return console && "function" == typeof console.warn && console.warn(e);
  },
  tt = null,
  rt = function rt(e, t) {
    var r = e.baseTag,
      n = e.bodyAttributes,
      o = e.htmlAttributes,
      i = e.linkTags,
      a = e.metaTags,
      c = e.noscriptTags,
      u = e.onChangeClientState,
      s = e.scriptTags,
      f = e.styleTags,
      l = e.title,
      p = e.titleAttributes;
    it(be.BODY, n), it(be.HTML, o), ot(l, p);
    var y = {
        baseTag: at(be.BASE, r),
        linkTags: at(be.LINK, i),
        metaTags: at(be.META, a),
        noscriptTags: at(be.NOSCRIPT, c),
        scriptTags: at(be.SCRIPT, s),
        styleTags: at(be.STYLE, f)
      },
      d = {},
      m = {};
    Object.keys(y).forEach(function (e) {
      var t = y[e],
        r = t.newTags,
        n = t.oldTags;
      r.length && (d[e] = r), n.length && (m[e] = y[e].oldTags);
    }), t && t(), u(e, d, m);
  },
  nt = function nt(e) {
    return Array.isArray(e) ? e.join("") : e;
  },
  ot = function ot(e, t) {
    void 0 !== e && document.title !== e && (document.title = nt(e)), it(be.TITLE, t);
  },
  it = function it(e, t) {
    var r = document.getElementsByTagName(e)[0];
    if (r) {
      for (var n = r.getAttribute("data-react-helmet"), o = n ? n.split(",") : [], i = [].concat(o), a = Object.keys(t), c = 0; c < a.length; c++) {
        var u = a[c],
          s = t[u] || "";
        r.getAttribute(u) !== s && r.setAttribute(u, s), -1 === o.indexOf(u) && o.push(u);
        var f = i.indexOf(u);
        -1 !== f && i.splice(f, 1);
      }
      for (var l = i.length - 1; l >= 0; l--) {
        r.removeAttribute(i[l]);
      }
      o.length === i.length ? r.removeAttribute("data-react-helmet") : r.getAttribute("data-react-helmet") !== a.join(",") && r.setAttribute("data-react-helmet", a.join(","));
    }
  },
  at = function at(e, t) {
    var r = document.head || document.querySelector(be.HEAD),
      n = r.querySelectorAll(e + "[data-react-helmet]"),
      o = Array.prototype.slice.call(n),
      i = [],
      a = void 0;
    return t && t.length && t.forEach(function (t) {
      var r = document.createElement(e);
      for (var n in t) {
        if (t.hasOwnProperty(n)) if (n === Oe) r.innerHTML = t.innerHTML;else if (n === ge) r.styleSheet ? r.styleSheet.cssText = t.cssText : r.appendChild(document.createTextNode(t.cssText));else {
          var c = void 0 === t[n] ? "" : t[n];
          r.setAttribute(n, c);
        }
      }
      r.setAttribute("data-react-helmet", "true"), o.some(function (e, t) {
        return a = t, r.isEqualNode(e);
      }) ? o.splice(a, 1) : i.push(r);
    }), o.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), i.forEach(function (e) {
      return r.appendChild(e);
    }), {
      oldTags: o,
      newTags: i
    };
  },
  ct = function ct(e) {
    return Object.keys(e).reduce(function (t, r) {
      var n = void 0 !== e[r] ? r + '="' + e[r] + '"' : "" + r;
      return t ? t + " " + n : n;
    }, "");
  },
  ut = function ut(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return Object.keys(e).reduce(function (t, r) {
      return t[xe[r] || r] = e[r], t;
    }, t);
  },
  st = function st(t, r, n) {
    switch (t) {
      case be.TITLE:
        return {
          toComponent: function toComponent() {
            return t = r.title, n = r.titleAttributes, (o = {
              key: t
            })["data-react-helmet"] = !0, i = ut(n, o), [e.createElement(be.TITLE, i, t)];
            var t, n, o, i;
          },
          toString: function toString() {
            return function (e, t, r, n) {
              var o = ct(r),
                i = nt(t);
              return o ? "<" + e + ' data-react-helmet="true" ' + o + ">" + Ye(i, n) + "</" + e + ">" : "<" + e + ' data-react-helmet="true">' + Ye(i, n) + "</" + e + ">";
            }(t, r.title, r.titleAttributes, n);
          }
        };
      case ye:
      case de:
        return {
          toComponent: function toComponent() {
            return ut(r);
          },
          toString: function toString() {
            return ct(r);
          }
        };
      default:
        return {
          toComponent: function toComponent() {
            return function (t, r) {
              return r.map(function (r, n) {
                var o,
                  i = ((o = {
                    key: n
                  })["data-react-helmet"] = !0, o);
                return Object.keys(r).forEach(function (e) {
                  var t = xe[e] || e;
                  if (t === Oe || t === ge) {
                    var n = r.innerHTML || r.cssText;
                    i.dangerouslySetInnerHTML = {
                      __html: n
                    };
                  } else i[t] = r[e];
                }), e.createElement(t, i);
              });
            }(t, r);
          },
          toString: function toString() {
            return function (e, t, r) {
              return t.reduce(function (t, n) {
                var o = Object.keys(n).filter(function (e) {
                    return !(e === Oe || e === ge);
                  }).reduce(function (e, t) {
                    var o = void 0 === n[t] ? t : t + '="' + Ye(n[t], r) + '"';
                    return e ? e + " " + o : o;
                  }, ""),
                  i = n.innerHTML || n.cssText || "",
                  a = -1 === Le.indexOf(e);
                return t + "<" + e + ' data-react-helmet="true" ' + o + (a ? "/>" : ">" + i + "</" + e + ">");
              }, "");
            }(t, r, n);
          }
        };
    }
  },
  ft = function ft(e) {
    var t = e.baseTag,
      r = e.bodyAttributes,
      n = e.encode,
      o = e.htmlAttributes,
      i = e.linkTags,
      a = e.metaTags,
      c = e.noscriptTags,
      u = e.scriptTags,
      s = e.styleTags,
      f = e.title,
      l = void 0 === f ? "" : f,
      p = e.titleAttributes;
    return {
      base: st(be.BASE, t, n),
      bodyAttributes: st(ye, r, n),
      htmlAttributes: st(de, o, n),
      link: st(be.LINK, i, n),
      meta: st(be.META, a, n),
      noscript: st(be.NOSCRIPT, c, n),
      script: st(be.SCRIPT, u, n),
      style: st(be.STYLE, s, n),
      title: st(be.TITLE, {
        title: l,
        titleAttributes: p
      }, n)
    };
  },
  lt = re(function (e) {
    return {
      baseTag: We([Te, Pe], e),
      bodyAttributes: ze(ye, e),
      defer: Je(e, Ie),
      encode: Je(e, _e),
      htmlAttributes: ze(de, e),
      linkTags: Ke(be.LINK, [Ce, Te], e),
      metaTags: Ke(be.META, [Ee, ve, we, Ae, Se], e),
      noscriptTags: Ke(be.NOSCRIPT, [Oe], e),
      onChangeClientState: Ue(e),
      scriptTags: Ke(be.SCRIPT, [je, Oe], e),
      styleTags: Ke(be.STYLE, [ge], e),
      title: Be(e),
      titleAttributes: ze(me, e)
    };
  }, function (e) {
    tt && Ze(tt), e.defer ? tt = Xe(function () {
      rt(e, function () {
        tt = null;
      });
    }) : (rt(e), tt = null);
  }, ft)(function () {
    return null;
  }),
  pt = (se = lt, le = fe = function (t) {
    function r() {
      return De(this, r), He(this, t.apply(this, arguments));
    }
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(r, t), r.prototype.shouldComponentUpdate = function (e) {
      return !pe(this.props, e);
    }, r.prototype.mapNestedChildrenToProps = function (e, t) {
      if (!t) return null;
      switch (e.type) {
        case be.SCRIPT:
        case be.NOSCRIPT:
          return {
            innerHTML: t
          };
        case be.STYLE:
          return {
            cssText: t
          };
      }
      throw new Error("<" + e.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    }, r.prototype.flattenArrayTypeChildren = function (e) {
      var t,
        r = e.child,
        n = e.arrayTypeChildren,
        o = e.newChildProps,
        i = e.nestedChildren;
      return Ve({}, n, ((t = {})[r.type] = [].concat(n[r.type] || [], [Ve({}, o, this.mapNestedChildrenToProps(r, i))]), t));
    }, r.prototype.mapObjectTypeChildren = function (e) {
      var t,
        r,
        n = e.child,
        o = e.newProps,
        i = e.newChildProps,
        a = e.nestedChildren;
      switch (n.type) {
        case be.TITLE:
          return Ve({}, o, ((t = {})[n.type] = a, t.titleAttributes = Ve({}, i), t));
        case be.BODY:
          return Ve({}, o, {
            bodyAttributes: Ve({}, i)
          });
        case be.HTML:
          return Ve({}, o, {
            htmlAttributes: Ve({}, i)
          });
      }
      return Ve({}, o, ((r = {})[n.type] = Ve({}, i), r));
    }, r.prototype.mapArrayTypeChildrenToProps = function (e, t) {
      var r = Ve({}, t);
      return Object.keys(e).forEach(function (t) {
        var n;
        r = Ve({}, r, ((n = {})[t] = e[t], n));
      }), r;
    }, r.prototype.warnOnInvalidChildren = function (e, t) {
      if ("production" !== process.env.NODE_ENV) {
        if (!he.some(function (t) {
          return e.type === t;
        })) return "function" == typeof e.type ? et("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.") : et("Only elements types " + he.join(", ") + " are allowed. Helmet does not support rendering <" + e.type + "> elements. Refer to our API for more information.");
        if (t && "string" != typeof t && (!Array.isArray(t) || t.some(function (e) {
          return "string" != typeof e;
        }))) throw new Error("Helmet expects a string as a child of <" + e.type + ">. Did you forget to wrap your children in braces? ( <" + e.type + ">{``}</" + e.type + "> ) Refer to our API for more information.");
      }
      return !0;
    }, r.prototype.mapChildrenToProps = function (t, r) {
      var n = this,
        o = {};
      return e.Children.forEach(t, function (e) {
        if (e && e.props) {
          var t = e.props,
            i = t.children,
            a = function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return Object.keys(e).reduce(function (t, r) {
                return t[Re[r] || r] = e[r], t;
              }, t);
            }(qe(t, ["children"]));
          switch (n.warnOnInvalidChildren(e, i), e.type) {
            case be.LINK:
            case be.META:
            case be.NOSCRIPT:
            case be.SCRIPT:
            case be.STYLE:
              o = n.flattenArrayTypeChildren({
                child: e,
                arrayTypeChildren: o,
                newChildProps: a,
                nestedChildren: i
              });
              break;
            default:
              r = n.mapObjectTypeChildren({
                child: e,
                newProps: r,
                newChildProps: a,
                nestedChildren: i
              });
          }
        }
      }), r = this.mapArrayTypeChildrenToProps(o, r);
    }, r.prototype.render = function () {
      var t = this.props,
        r = t.children,
        n = qe(t, ["children"]),
        o = Ve({}, n);
      return r && (o = this.mapChildrenToProps(r, o)), e.createElement(se, o);
    }, Fe(r, null, [{
      key: "canUseDOM",
      set: function set(e) {
        se.canUseDOM = e;
      }
    }]), r;
  }(e.Component), fe.propTypes = {
    base: G.object,
    bodyAttributes: G.object,
    children: G.oneOfType([G.arrayOf(G.node), G.node]),
    defaultTitle: G.string,
    defer: G.bool,
    encodeSpecialCharacters: G.bool,
    htmlAttributes: G.object,
    link: G.arrayOf(G.object),
    meta: G.arrayOf(G.object),
    noscript: G.arrayOf(G.object),
    onChangeClientState: G.func,
    script: G.arrayOf(G.object),
    style: G.arrayOf(G.object),
    title: G.string,
    titleAttributes: G.object,
    titleTemplate: G.string
  }, fe.defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0
  }, fe.peek = se.peek, fe.rewind = function () {
    var e = se.rewind();
    return e || (e = ft({
      baseTag: [],
      bodyAttributes: {},
      encodeSpecialCharacters: !0,
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    })), e;
  }, le);
pt.renderStatic = pt.rewind;
var yt = function yt(_ref) {
  var r = _ref.children,
    n = _ref.htmlAttributes,
    o = _ref.meta,
    i = _ref.relatedPaths,
    a = _ref.baseUrl,
    c = _objectWithoutProperties(_ref, _excluded);
  var u = !!(n !== null && n !== void 0 && n.lang && i && a);
  return e.createElement(pt, t({
    htmlAttributes: n
  }, c), o && o.map(function (t) {
    var _e$createElement;
    var r = "meta-".concat(t.name, "-").concat(t.attribute);
    return "title" === t.name ? e.createElement("title", {
      key: r
    }, t.content) : e.createElement("meta", (_e$createElement = {
      key: r
    }, _defineProperty(_e$createElement, t.attribute, t.name), _defineProperty(_e$createElement, "content", t.content), _e$createElement));
  }), u && Object.keys(i).filter(function (e) {
    return e !== (n === null || n === void 0 ? void 0 : n.lang);
  }).map(function (t) {
    var r = "".concat(a).concat(i[t]);
    return e.createElement("link", {
      key: "href-link-".concat(r),
      rel: "alternate",
      hrefLang: t,
      href: r
    });
  }), r);
};
export { yt as SEO };